// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__NHeVJ","SpinnerText":"Spinner_SpinnerText__4o5x0"};